import { render, staticRenderFns } from "./DeviationList.vue?vue&type=template&id=69874470&scoped=true&"
import script from "./DeviationList.vue?vue&type=script&lang=js&"
export * from "./DeviationList.vue?vue&type=script&lang=js&"
import style0 from "./DeviationList.vue?vue&type=style&index=0&id=69874470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69874470",
  null
  
)

/* custom blocks */
import block0 from "./DeviationList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports